import { Package } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { C } from "./homeTheme";
import { useTranslation } from "react-i18next";

export function DeliveryAddressDialog({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="max-w-sm mx-auto"
        style={{
          background: C.bg,
          border: `1px solid ${C.border}`,
          color: C.text,
        }}
      >
        <DialogHeader>
          <DialogTitle style={{ color: C.primary }}>
            {t("homePage.deliveryAddressDialog.title")}
          </DialogTitle>
        </DialogHeader>
        <div className="py-8 flex flex-col items-center gap-4">
          <div
            className="w-16 h-16 rounded-full flex items-center justify-center"
            style={{ background: "rgba(0,212,170,0.08)" }}
          >
            <Package size={28} style={{ color: C.primary }} />
          </div>
          <div className="text-center">
            <p className="font-semibold text-sm">
              {t("homePage.deliveryAddressDialog.producing")}
            </p>
            <p
              className="text-[11px] mt-2 px-4 leading-relaxed"
              style={{ color: C.muted }}
            >
              {t("homePage.deliveryAddressDialog.deliveryNote")}
            </p>
          </div>
          <Button className="w-full btn-primary" onClick={onClose}>
            {t("homePage.deliveryAddressDialog.confirm")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
